"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchFlights = exports.getAirlineIcon = exports.getAirlines = exports.getLocationDump = exports.getLocationById = exports.searchLocationsByBox = exports.searchLocationsByRadius = exports.searchLocationsByTerm = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _qs = _interopRequireDefault(require("qs"));

var _flightSearchParameterBuilder = _interopRequireDefault(require("./flightSearchParameterBuilder"));

var _constants = require("./constants");

var _Object$freeze, _Object$freeze2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var locationTypeValues = Object.freeze((_Object$freeze = {}, _defineProperty(_Object$freeze, _constants.LOCATION_TYPES.AIRPORT, 'airport'), _defineProperty(_Object$freeze, _constants.LOCATION_TYPES.AUTONOMOUS_TERRITORY, 'autonomous_territory'), _defineProperty(_Object$freeze, _constants.LOCATION_TYPES.CITY, 'city'), _defineProperty(_Object$freeze, _constants.LOCATION_TYPES.COUNTRY, 'country'), _defineProperty(_Object$freeze, _constants.LOCATION_TYPES.SUBDIVISION, 'subdivision'), _Object$freeze));
var locationSortTypeValues = Object.freeze((_Object$freeze2 = {}, _defineProperty(_Object$freeze2, _constants.LOCATION_RESULTS_SORT_TYPES.ASCENDING_NAME, 'name'), _defineProperty(_Object$freeze2, _constants.LOCATION_RESULTS_SORT_TYPES.DESCENDING_NAME, '-name'), _defineProperty(_Object$freeze2, _constants.LOCATION_RESULTS_SORT_TYPES.ASCENDING_RANK, 'rank'), _defineProperty(_Object$freeze2, _constants.LOCATION_RESULTS_SORT_TYPES.DESCENDING_RANK, '-rank'), _Object$freeze2));

var paramsSerializer = function paramsSerializer(params) {
  return _qs["default"].stringify(params, {
    arrayFormat: 'repeat'
  });
};
/* https://skypickerpublicapi.docs.apiary.io/#reference/locations/locations-collection/search-by-query */


var searchLocationsByTerm = function searchLocationsByTerm(_ref) {
  var term = _ref.term,
      locale = _ref.locale,
      _ref$locationTypes = _ref.locationTypes,
      locationTypes = _ref$locationTypes === void 0 ? [] : _ref$locationTypes,
      limit = _ref.limit;
  return _axios["default"].get("".concat(_constants.SKYPICKER_BASE_API_URL, "/locations"), {
    params: {
      term: term,
      locale: locale,
      location_types: locationTypes.map(function (type) {
        return locationTypeValues[type];
      }),
      limit: limit
    },
    paramsSerializer: paramsSerializer
  }).then(function (response) {
    return response.data;
  });
};
/* https://skypickerpublicapi.docs.apiary.io/#reference/locations/locations-collection/search-by-radius */


exports.searchLocationsByTerm = searchLocationsByTerm;

var searchLocationsByRadius = function searchLocationsByRadius(_ref2) {
  var coordinate = _ref2.coordinate,
      radius = _ref2.radius,
      locale = _ref2.locale,
      _ref2$locationTypes = _ref2.locationTypes,
      locationTypes = _ref2$locationTypes === void 0 ? [] : _ref2$locationTypes,
      limit = _ref2.limit,
      _ref2$sortTypes = _ref2.sortTypes,
      sortTypes = _ref2$sortTypes === void 0 ? [] : _ref2$sortTypes;
  return _axios["default"].get("".concat(_constants.SKYPICKER_BASE_API_URL, "/locations"), {
    params: {
      type: 'radius',
      lat: coordinate.latitude,
      lon: coordinate.longitude,
      radius: radius,
      locale: locale,
      location_types: locationTypes.map(function (type) {
        return locationTypeValues[type];
      }),
      limit: limit,
      sort: sortTypes.map(function (type) {
        return locationSortTypeValues[type];
      })
    },
    paramsSerializer: paramsSerializer
  }).then(function (response) {
    return response.data;
  });
};
/* https://skypickerpublicapi.docs.apiary.io/#reference/locations/locations-collection/search-by-box */


exports.searchLocationsByRadius = searchLocationsByRadius;

var searchLocationsByBox = function searchLocationsByBox(_ref3) {
  var lowCoordinate = _ref3.lowCoordinate,
      highCoordinate = _ref3.highCoordinate,
      locale = _ref3.locale,
      _ref3$locationTypes = _ref3.locationTypes,
      locationTypes = _ref3$locationTypes === void 0 ? [] : _ref3$locationTypes,
      limit = _ref3.limit,
      _ref3$sortTypes = _ref3.sortTypes,
      sortTypes = _ref3$sortTypes === void 0 ? [] : _ref3$sortTypes;
  return _axios["default"].get("".concat(_constants.SKYPICKER_BASE_API_URL, "/locations"), {
    params: {
      type: 'box',
      low_lat: lowCoordinate.latitude,
      low_lon: lowCoordinate.longitude,
      high_lat: highCoordinate.latitude,
      high_lon: highCoordinate.longitude,
      locale: locale,
      location_types: locationTypes.map(function (type) {
        return locationTypeValues[type];
      }),
      limit: limit,
      sort: sortTypes.map(function (type) {
        return locationSortTypeValues[type];
      })
    },
    paramsSerializer: paramsSerializer
  }).then(function (response) {
    return response.data;
  });
};
/* https://skypickerpublicapi.docs.apiary.io/#reference/locations/locations-collection/get-by-id */


exports.searchLocationsByBox = searchLocationsByBox;

var getLocationById = function getLocationById(_ref4) {
  var id = _ref4.id,
      locale = _ref4.locale;
  return _axios["default"].get("".concat(_constants.SKYPICKER_BASE_API_URL, "/locations"), {
    params: {
      type: 'id',
      id: id,
      locale: locale
    }
  }).then(function (response) {
    return response.data;
  });
};
/* https://skypickerpublicapi.docs.apiary.io/#reference/locations/locations-collection/get-dump */


exports.getLocationById = getLocationById;

var getLocationDump = function getLocationDump(_ref5) {
  var locale = _ref5.locale,
      _ref5$locationTypes = _ref5.locationTypes,
      locationTypes = _ref5$locationTypes === void 0 ? [] : _ref5$locationTypes,
      limit = _ref5.limit,
      _ref5$sortTypes = _ref5.sortTypes,
      sortTypes = _ref5$sortTypes === void 0 ? [] : _ref5$sortTypes;
  return _axios["default"].get("".concat(_constants.SKYPICKER_BASE_API_URL, "/locations"), {
    params: {
      type: 'dump',
      locale: locale,
      location_types: locationTypes.map(function (type) {
        return locationTypeValues[type];
      }),
      limit: limit,
      sort: sortTypes.map(function (type) {
        return locationSortTypeValues[type];
      })
    },
    paramsSerializer: paramsSerializer
  }).then(function (response) {
    return response.data;
  });
};
/* https://skypickerpublicapi.docs.apiary.io/#reference/airlines/get */


exports.getLocationDump = getLocationDump;

var getAirlines = function getAirlines() {
  return _axios["default"].get("".concat(_constants.SKYPICKER_BASE_API_URL, "/airlines")).then(function (response) {
    return response.data;
  });
};
/* https://skypickerpublicapi.docs.apiary.io/#reference/airline-logos/get */


exports.getAirlines = getAirlines;

var getAirlineIcon = function getAirlineIcon(airlineCode) {
  return _axios["default"].get("https://images.kiwi.com/airlines/64/".concat(airlineCode, ".png"));
};
/* https://skypickerpublicapi.docs.apiary.io/#reference/airline-logos/get */


exports.getAirlineIcon = getAirlineIcon;

var searchFlights = function searchFlights(_ref6) {
  var departureIdentifier = _ref6.departureIdentifier,
      arrivalIdentifier = _ref6.arrivalIdentifier,
      departureDateTimeRange = _ref6.departureDateTimeRange,
      returnDepartureDateTimeRange = _ref6.returnDepartureDateTimeRange,
      maximumHoursInFlight = _ref6.maximumHoursInFlight,
      passengerCount = _ref6.passengerCount,
      directFlightsOnly = _ref6.directFlightsOnly,
      currencyCode = _ref6.currencyCode,
      priceRange = _ref6.priceRange,
      maximumStopOverCount = _ref6.maximumStopOverCount,
      airlinesFilter = _ref6.airlinesFilter,
      partner = _ref6.partner,
      locale = _ref6.locale,
      offset = _ref6.offset,
      limit = _ref6.limit,
      sortType = _ref6.sortType;
  return _axios["default"].get("".concat(_constants.SKYPICKER_BASE_API_URL, "/flights"), {
    params: (0, _flightSearchParameterBuilder["default"])({
      departureIdentifier: departureIdentifier,
      arrivalIdentifier: arrivalIdentifier,
      departureDateTimeRange: departureDateTimeRange,
      returnDepartureDateTimeRange: returnDepartureDateTimeRange,
      maximumHoursInFlight: maximumHoursInFlight,
      passengerCount: passengerCount,
      directFlightsOnly: directFlightsOnly,
      currencyCode: currencyCode,
      priceRange: priceRange,
      maximumStopOverCount: maximumStopOverCount,
      airlinesFilter: airlinesFilter,
      partner: partner,
      locale: locale,
      offset: offset,
      limit: limit,
      sortType: sortType
    }),
    paramsSerializer: paramsSerializer
  }).then(function (response) {
    return response.data;
  });
};

exports.searchFlights = searchFlights;


//////////////////
// WEBPACK FOOTER
// ./~/skypicker/build/client.js
// module id = 1306
// module chunks = 231608221292675